<template>
  <div class="pat-wrapper">
    <!-- Header -->
    <div class="pat-header">
      <div class="contract-info">
        <div class="contract-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect width="20" height="14" x="2" y="5" rx="2" />
            <line x1="2" x2="22" y1="10" y2="10" />
          </svg>
        </div>
        <div class="contract-details">
          <span class="contract-label">Pago Automático con Tarjeta</span>
          <span class="contract-number">PAT - Tarjetas de Crédito</span>
        </div>
      </div>
      <div class="cards-count">
        <span
          class="count-badge"
          :class="{ 'has-cards': cards && cards.length > 0 }"
        >
          <span class="count-dot"></span>
          {{
            cards && cards.length > 0
              ? cards.length +
                " tarjeta" +
                (cards.length > 1 ? "s" : "") +
                " registrada" +
                (cards.length > 1 ? "s" : "")
              : "Sin tarjetas"
          }}
        </span>
      </div>
    </div>

    <!-- Alert for multiple contracts -->
    <div
      class="info-alert warning"
      v-if="this.$store.state.apartments.length > 1"
    >
      <div class="alert-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"
          />
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
        </svg>
      </div>
      <p class="alert-text">
        Tienes más de un contrato. Debes seleccionar con el botón "Agregar
        bienes" cuál deseas activar con tus tarjetas.
      </p>
    </div>

    <!-- Add Card Button -->
    <div class="add-card-section">
      <button class="add-card-btn" @click="$bvModal.show('modal-add-card')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14" />
          <path d="M12 5v14" />
        </svg>
        Agregar Nueva Tarjeta
      </button>
    </div>

    <!-- Cards List - Desktop -->
    <div class="cards-container" v-if="cards && cards.length > 0">
      <!-- Desktop Table -->
      <div class="cards-table-wrapper d-none d-lg-block">
        <table class="cards-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Tipo</th>
              <th>Número de tarjeta</th>
              <th v-if="can_change_asset">Bienes</th>
              <th v-if="$store.state.apartments.length == 1">Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(card, key) in cards" :key="'card-' + key">
              <td>
                <span class="date-value">{{
                  card.created_at | moment("DD-MM-YYYY")
                }}</span>
              </td>
              <td>
                <div class="card-type-badge" v-if="card.card_type">
                  <font-awesome-icon
                    :icon="set_icon_card(card.card_type)"
                    size="lg"
                  />
                  <span>{{ card.card_type }}</span>
                </div>
              </td>
              <td>
                <span class="card-number" v-if="card.card_number">
                  •••• •••• ••••
                  {{ card.card_number.substr(card.card_number.length - 4) }}
                </span>
              </td>
              <td v-if="can_change_asset">
                <button class="action-btn secondary" @click="open_modal(card)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M5 12h14" />
                    <path d="M12 5v14" />
                  </svg>
                  Agregar Bienes
                </button>
              </td>
              <td v-if="$store.state.apartments.length == 1">
                <span
                  class="status-badge active"
                  v-if="card.default"
                  title="Los cargos se realizarán a esta tarjeta"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  Principal
                </span>
                <button
                  class="action-btn outline"
                  v-else
                  @click="set_default_card(card, key)"
                  title="Puedes realizar cargos a esta tarjeta si la activas"
                >
                  Activar Principal
                </button>
              </td>
              <td>
                <button
                  class="action-btn danger"
                  @click="delete_card(card, key)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M3 6h18" />
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                  </svg>
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile Cards -->
      <div class="cards-mobile d-lg-none">
        <div
          class="card-item"
          v-for="(card, key) in cards"
          :key="'mobile-card-' + key"
        >
          <div class="card-item-header">
            <div class="card-info">
              <div class="card-type-icon" v-if="card.card_type">
                <font-awesome-icon
                  :icon="set_icon_card(card.card_type)"
                  size="2x"
                />
              </div>
              <div class="card-details">
                <span class="card-number-mobile" v-if="card.card_number">
                  ••••
                  {{ card.card_number.substr(card.card_number.length - 4) }}
                </span>
                <span class="card-date">{{
                  card.created_at | moment("DD-MM-YYYY")
                }}</span>
              </div>
            </div>
            <span
              class="status-badge active small"
              v-if="card.default && $store.state.apartments.length == 1"
            >
              Principal
            </span>
          </div>
          <div class="card-item-actions">
            <button
              class="action-btn secondary small"
              v-if="can_change_asset"
              @click="open_modal(card)"
            >
              Agregar Bienes
            </button>
            <button
              class="action-btn outline small"
              v-if="$store.state.apartments.length == 1 && !card.default"
              @click="set_default_card(card, key)"
            >
              Activar Principal
            </button>
            <button
              class="action-btn danger small"
              @click="delete_card(card, key)"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>

      <!-- Footer note -->
      <div class="cards-footer-note">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
        <span
          >* Los cargos automáticos se realizarán a la tarjeta marcada como
          Principal</span
        >
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" v-else>
      <div class="empty-illustration">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect width="20" height="14" x="2" y="5" rx="2" />
          <line x1="2" x2="22" y1="10" y2="10" />
        </svg>
      </div>
      <h3 class="empty-title">No tienes tarjetas registradas</h3>
      <p class="empty-description">
        Agrega una tarjeta de crédito para automatizar tus pagos mensuales.
      </p>
    </div>

    <!-- Modal Add Card -->
    <b-modal
      scrollable
      id="modal-add-card"
      size="xl"
      hide-footer
      modal-class="modern-modal"
    >
      <template #modal-title>
        <div class="modal-title-custom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect width="20" height="14" x="2" y="5" rx="2" />
            <line x1="2" x2="22" y1="10" y2="10" />
          </svg>
          <span>Agregar Tarjeta de Crédito</span>
        </div>
      </template>
      <term-conditions :legal_name="legal_name"></term-conditions>
      <div class="modal-footer-custom">
        <button class="accept-btn" @click="add_card()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Acepto Términos y Condiciones
        </button>
      </div>
    </b-modal>

    <!-- Modal Asset Card -->
    <b-modal id="modal-asset-card" hide-footer modal-class="modern-modal">
      <template #modal-title>
        <div class="modal-title-custom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span>Agregar Bien a Tarjeta</span>
        </div>
      </template>
      <div class="assets-list">
        <div
          class="asset-item"
          v-for="(apartment, asset_id) in this.$store.state.apartments"
          :key="asset_id"
        >
          <div class="asset-info">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            <span>{{ apartment.asset_type }} {{ apartment.number }}</span>
          </div>
          <button
            class="action-btn secondary small"
            v-if="set_button_add_asset(apartment.asset_id)"
            @click="set_asset_card(apartment.asset_id)"
          >
            Agregar
          </button>
          <button
            class="action-btn danger small"
            v-else
            @click="delete_asset_card(apartment.asset_id)"
          >
            Quitar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Hidden form for Transbank -->
    <form
      id="webpay-oneclick-form"
      ref="form"
      action=""
      accept-charset="UTF-8"
      method="post"
    >
      <input
        id="webpay-oneclick-token"
        type="hidden"
        name="TBK_TOKEN"
        v-model="transbank.token"
      />
    </form>
  </div>
</template>

<script>
import TermConditions from "./Oneclick-terms.vue";

export default {
  name: "payments",
  components: {
    TermConditions,
  },
  props: {
    asset_id: null,
    project_id: { default: null },
  },
  data() {
    return {
      current_card_asset: { assets: [] },
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      transbank: {
        token: "",
        url: "",
        monto: "",
        concept: "",
        back_url: window.location.href,
        id: "",
        loading: false,
      },
      pageOfItems: [],
      loading: true,
    };
  },
  computed: {
    cards() {
      return this.$store.getters.getCards;
    },
    can_change_asset() {
      return this.$store.state.apartments.length > 1;
    },
    legal_name() {
      let name = null;
      switch (this.project_id) {
        case 1:
          name = "Marcha Blanca SPA";
          break;
        case 2:
          name = "INES DE SUAREZ SPA";
          break;
        case 3:
          name = "San Bernardo SpA";
          break;
        default:
          name = "Neourbe";
          break;
      }
      return name;
    },
  },
  methods: {
    delete_asset_card(asset_id) {
      this.$swal({
        title: "¿Estás seguro que deseas borrar este bien a esta tarjeta?",
        text: "Se dejarán de realizaran cobros de este bien a esta tarjeta",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#5cb85c",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Confirmar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post("payments/oneclick/delete_asset_card", {
              asset_id: asset_id,
              card_id: this.current_card_asset.card_id,
            })
            .then(() => {
              this.current_card_asset.assets =
                this.current_card_asset.assets.filter(
                  (element) => element != asset_id
                );
              this.$swal("¡Éxito!", "Bien borrado con éxito", "success");
            })
            .catch(() => {
              this.$swal("¡Parece que hubo un error!", "", "info");
            });
        }
      });
    },
    set_button_add_asset(asset_id) {
      let is_in = this.current_card_asset.assets.filter(
        (element) => element == asset_id
      );
      return is_in.length == 0;
    },
    set_asset_card(asset_id) {
      this.$swal({
        title: "¿Estás seguro que deseas agregar este bien a esta tarjeta?",
        text: "Se realizaran cobros de este bien a esta tarjeta",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#5cb85c",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Confirmar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post("payments/oneclick/add_card_asset", {
              asset_id: asset_id,
              card_id: this.current_card_asset.card_id,
            })
            .then(() => {
              this.current_card_asset.assets.push(asset_id);
              this.$swal("¡Éxito!", "Bien agregado con éxito", "success");
            })
            .catch(() => {
              this.$swal("¡Parece que hubo un error!", "", "info");
            });
        }
      });
    },
    open_modal(card) {
      this.current_card_asset = card;
      this.$bvModal.show("modal-asset-card");
    },
    set_icon_card(icon_card) {
      if (icon_card == "RedCompra") {
        return ["fas", "credit-card"];
      } else {
        return ["fab", "cc-" + icon_card.toLowerCase()];
      }
    },
    set_default_card(card) {
      this.$swal({
        title: "¿Estás seguro que deseas agregar esta tarjeta como principal?",
        text: "Todos los cobros se harán a esta tarjeta",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#5cb85c",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Confirmar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .post("payments/oneclick/set_default", { id: card.card_id })
            .then(() => {
              this.cards.forEach((card) => (card.default = false));
              card.default = true;
              this.$swal("¡Éxito!", "Tarjeta agregada con éxito", "success");
            })
            .catch(() => {
              this.$swal("¡Parece que hubo un error!", "", "info");
            });
        }
      });
    },
    add_card() {
      let return_path = this.$router.currentRoute.fullPath.substring(1);
      this.axios
        .post("payments/oneclick/add_card", {
          return_path: return_path,
          assets: this.$store.state.apartments,
          project_id: this.project_id,
        })
        .then((result) => {
          this.transbank.token = result.data.token;
          this.transbank.url = result.data.url_webpay;
          this.transbank.loading = false;
          if (this.transbank.token)
            document.getElementById("webpay-oneclick-token").value =
              result.data.token;
          document.getElementById("webpay-oneclick-form").action =
            result.data.url_webpay;
          document.getElementById("webpay-oneclick-form").submit();
        })
        .catch(() => {
          this.$swal("¡Parece que hubo un error!", "", "info");
          this.transbank.loading = false;
        });
    },
    delete_card(card, key) {
      this.$swal({
        title: "¿Estás seguro que deseas borrar esta tarjeta?",
        text: "Si es tu ultima tarjeta no se podrá cobrarar de forma automática tus pagos",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios
            .delete(`payments/oneclick/${card.card_id}`)
            .then(() => {
              this.cards.splice(key, 1);
              this.$swal("¡Éxito!", "Tarjeta borrada con éxito", "success");
            })
            .catch(() => {
              this.$swal("¡Parece que hubo un error!", "", "info");
            });
        }
      });
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    showModal(payment) {
      this.$refs["my-modal"].show();
      this.transbank.id = payment.codigo;
      this.transbank.monto = parseInt(payment.montoPago * payment.valorUF);
    },
    is_payed(payment) {
      if (payment.reciboPago === undefined) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
/* ===== Wrapper ===== */
.pat-wrapper {
  padding: 0;
}

/* ===== Header ===== */
.pat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.contract-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contract-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  border-radius: 12px;
  color: #db2777;
}

.contract-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contract-label {
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
}

.contract-number {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.count-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #fef3c7;
  color: #d97706;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

.count-badge.has-cards {
  background: #ecfdf5;
  color: #059669;
}

.count-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}

/* ===== Alert ===== */
.info-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.info-alert.warning {
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.info-alert.warning .alert-icon {
  color: #d97706;
}

.info-alert.warning .alert-text {
  color: #92400e;
}

.alert-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.alert-text {
  font-size: 0.9375rem;
  line-height: 1.5;
  margin: 0;
}

/* ===== Add Card Section ===== */
.add-card-section {
  margin-bottom: 20px;
}

.add-card-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  background: var(--color-btn, #3b82f6);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-card-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* ===== Cards Container ===== */
.cards-container {
  background: white;
  border-radius: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

/* ===== Desktop Table ===== */
.cards-table-wrapper {
  overflow-x: auto;
}

.cards-table {
  width: 100%;
  border-collapse: collapse;
}

.cards-table th {
  background: #f8fafc;
  padding: 16px 20px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
}

.cards-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.cards-table tr:last-child td {
  border-bottom: none;
}

.date-value {
  font-size: 0.875rem;
  color: #374151;
}

.card-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #f3f4f6;
  border-radius: 8px;
  font-size: 0.8125rem;
  color: #374151;
}

.card-number {
  font-family: "SF Mono", "Menlo", monospace;
  font-size: 0.9375rem;
  color: #1f2937;
  letter-spacing: 0.5px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 500;
}

.status-badge.active {
  background: #ecfdf5;
  color: #059669;
}

.status-badge.small {
  padding: 4px 10px;
  font-size: 0.75rem;
}

/* ===== Action Buttons ===== */
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.action-btn.secondary {
  background: #f3f4f6;
  color: #374151;
}

.action-btn.secondary:hover {
  background: #e5e7eb;
}

.action-btn.outline {
  background: transparent;
  border: 1px solid var(--color-btn, #3b82f6);
  color: var(--color-btn, #3b82f6);
}

.action-btn.outline:hover {
  background: rgba(59, 130, 246, 0.05);
}

.action-btn.danger {
  background: #fef2f2;
  color: #dc2626;
}

.action-btn.danger:hover {
  background: #fee2e2;
}

.action-btn.small {
  padding: 6px 12px;
  font-size: 0.75rem;
}

/* ===== Mobile Cards ===== */
.cards-mobile {
  padding: 12px;
}

.card-item {
  background: #f9fafb;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

.card-item:last-child {
  margin-bottom: 0;
}

.card-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.card-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-type-icon {
  color: #6b7280;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.card-number-mobile {
  font-family: "SF Mono", "Menlo", monospace;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
}

.card-date {
  font-size: 0.75rem;
  color: #6b7280;
}

.card-item-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* ===== Footer Note ===== */
.cards-footer-note {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  font-size: 0.8125rem;
  color: #6b7280;
}

/* ===== Empty State ===== */
.empty-state {
  text-align: center;
  padding: 60px 24px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.empty-illustration {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-radius: 50%;
  color: #9ca3af;
}

.empty-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
}

.empty-description {
  font-size: 0.9375rem;
  color: #6b7280;
  max-width: 300px;
  margin: 0 auto;
}

/* ===== Modal Styles ===== */
.modal-title-custom {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
}

.modal-title-custom svg {
  color: var(--color-btn, #3b82f6);
}

.modal-footer-custom {
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
  margin-top: 20px;
}

.accept-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 24px;
  background: #10b981;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.accept-btn:hover {
  background: #059669;
}

/* ===== Assets List ===== */
.assets-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.asset-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #f9fafb;
  border-radius: 12px;
}

.asset-info {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  color: #374151;
}

.asset-info svg {
  color: var(--color-btn, #3b82f6);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .pat-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 16px;
  }

  .contract-info {
    justify-content: center;
  }

  .cards-count {
    text-align: center;
  }

  .add-card-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .pat-header {
    padding: 12px;
    border-radius: 12px;
  }

  .contract-icon {
    width: 40px;
    height: 40px;
  }

  .contract-icon svg {
    width: 20px;
    height: 20px;
  }

  .contract-number {
    font-size: 1rem;
  }

  .empty-state {
    padding: 40px 20px;
  }

  .empty-illustration {
    width: 80px;
    height: 80px;
  }

  .empty-illustration svg {
    width: 40px;
    height: 40px;
  }
}
</style>
